import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)]"
      style={{ backgroundColor: "#D6D8CB", color: "#050505" }}
    >
      <h1 className="text-6xl font-bold mb-4" style={{ color: "#EE7B11" }}>
        404
      </h1>
      <h2 className="text-3xl font-semibold mb-4">Página não encontrada</h2>
      <p className="text-xl mb-8 text-center max-w-md">
        A página que você está procurando não existe ou foi movida.
      </p>
      <Button
        onClick={() => navigate("/inicio")}
        className="transition-colors"
        style={{
          backgroundColor: "#EE7B11",
          color: "#D6D8CB",
        }}
      >
        Voltar para o início
      </Button>
    </div>
  );
}
